import React, { useEffect, useState } from "react";
import FileInput from "../components/FileInput/FileInput";
import ImportList from "../components/ImportList/ImportList";
import Container from "../components/Container/Container";
import { fetchAll, Import } from "../services/import";
import { toast } from "react-toastify";

const Imports: React.FC = () => {
  const [imports, setImports] = useState<Import[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const onImportSuccess = (importRecord: Import) => {
    setImports((prevItems) => [importRecord, ...prevItems]);
  };

  useEffect(() => {
    const loadImports = async () => {
      try {
        const response = await fetchAll();
        setImports(response);
        setIsLoading(false);
      } catch {
        toast.error("Failed to load imports! Please, try again later!");
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };

    loadImports();
  }, []);

  return (
    <>
      <Container>
        <FileInput onImportSuccess={onImportSuccess} />
      </Container>
      <Container>
        {isLoading ? <div>Loading...</div> : <ImportList imports={imports} />}
      </Container>
    </>
  );
};

export default Imports;
